import { Controller } from "stimulus"
import Cleave from 'cleave.js'
import CleavePhone from 'cleave.js/dist/addons/cleave-phone.us'

export default class extends Controller
  initialize: ->
    new Cleave @element,
      phone: true
      phoneRegionCode: 'US'
      delimiter: '-'